<div class="match-secties">
	<header class="match-secties__header">
		<div class="match-secties__title">{{ titel() }}</div>
		<div class="match-secties__subtitle">{{ unmatchedCount() }} {{ unmatchedLabel() }}</div>
	</header>

	@if (hasCards()) {
		<div class="match-secties__columns">
			@for (column of columns(); track column.title) {
				<section class="match-secties__column">
					<h4 class="match-secties__column-title">{{ column.title }}</h4>
					<div class="match-secties__column-body">
						@if (column.cards.length > 0) {
							<div class="match-secties__cards-grid">
								@for (card of column.cards; track card.matchIndex) {
									<section class="match-card">
										<div class="match-card__section match-card__section--header">
											<div class="item-card item-card--target" [class.item-inactief]="card.doelInactief">
												<div class="item-card__title">{{ card.doelLabel }}</div>
											</div>
										</div>
										<div class="match-card__section">
											<app-multi-select-dropdown
												[allOptions]="card.options"
												[value]="card.bron"
												(valueChange)="onSelectionChanged(card.matchIndex, $event)"
												[placeholder]="placeholder()"
												[showSearchInput]="true"
											></app-multi-select-dropdown>
										</div>
									</section>
								}
							</div>
						} @else {
							<span class="empty-state">{{ column.emptyText }}</span>
						}
					</div>
				</section>
			}
		</div>
	} @else {
		<section class="match-secties__empty">
			<span class="empty-state">{{ emptyText() }}</span>
		</section>
	}
</div>
